// extracted by mini-css-extract-plugin
module.exports =  {"favorite":"femGtTHdC6qhGWauoyht","favoriteSelected":"IjXSyF7EG42mn1I3e67F"};